// extracted by mini-css-extract-plugin
module.exports = {"followButton":"styles_followButton__2Vrgx","unfollowButton":"styles_unfollowButton__1Iqk7"};